import React, { useContext } from "react";
import styled from "styled-components";
import { GlobalContext } from "../../Context/GlobalContext";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: ${(props) => (props.showPopup ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const PopupContainer = styled.div`
  position: relative;
  padding: 20px;
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #721c24;
  cursor: pointer;

  &:hover {
    color: #f5c6cb;
  }
`;

const Heading = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #721c24;
`;

const Message = styled.p`
  font-size: 1rem;
  margin-bottom: 15px;
  color: #721c24;
`;

const RetryButton = styled.button`
  background-color: #f5c6cb;
  color: #721c24;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #f1b0b7;
  }
`;
const ErrorComponent = ({
  message = "An unexpected error occurred",
  onRetry,
}) => {
  const { popupConfig, setPopupConfig } = useContext(GlobalContext);

  const onClose = () => {
    setPopupConfig({ ...popupConfig, show: false, subTitle: "" });
  }
  return (
    <Overlay showPopup={popupConfig.show}>
    <PopupContainer>
      <CloseButton onClick={onClose}>&times;</CloseButton>
      <Heading>Error</Heading>
      <Message>{message}</Message>
      {popupConfig.subTitle && <Message>{popupConfig.subTitle}</Message>}
      {onRetry && <RetryButton onClick={onRetry}>Try Again</RetryButton>}
    </PopupContainer>
  </Overlay>
  );
};

export default ErrorComponent;
